import cx from 'classnames';
import Img from 'mk2/components/Img';
import Link from 'mk2/components/Link';
import { UserEntity } from 'mk2/schemas';
import React from 'react';
import styles from './AvatarImg.mscss';

interface OwnProps {
    className?: string;
    user: UserEntity;
    href?: string;
    size?: 16 | 18 | 24 | 28 | 32 | 36 | 40 | 50 | 150;
    counsellorAvatar?: string;
}

// TODO: Add tooltip - use react bootstrap!!! - don't make own solution :)
class AvatarImg extends React.Component<OwnProps> {

    public static defaultProps: Partial<OwnProps> = {
        size: 50,
    };

    public shouldComponentUpdate(n: OwnProps) {
        const p = this.props;

        return n.user.avatar !== p.user.avatar
            || n.user.avatarCampaign !== p.user.avatarCampaign
            || n.user.activePlan !== p.user.activePlan;
    }

    public render() {
        const { user, size, href, className, counsellorAvatar } = this.props;
        const image = (
            <div className={styles.AvatarImg__container}>
                <Img lazy src={counsellorAvatar || (size === 150 ? user.avatarCampaign : user.avatar)} width={size} height={size} className={counsellorAvatar && styles[`AvatarImg--counselling`]}/>
            </div>
        );

        const strip = (
            <div className={styles.AvatarImg__strip} />
        );

        const showStrip = user.activePlan === 'plus' || user.activePlan === 'pro';

        const classes = cx(
            className, styles.AvatarImg,
            styles[`AvatarImg--${size}`], styles[`AvatarImg--${user.activePlan}`],
        );

        let container;
        if (href) {
            container = (
                <Link to={href} className={classes}>
                    {image}
                    {showStrip && strip}
                </Link>
            );
        } else {
            container = (
                <span className={classes}>
                    {image}
                    {showStrip && strip}
                </span>
            );
        }

        return container;
    }
}

export default AvatarImg;
